export default __webpack_public_path__ + "static/media/hoja-palmera.435fdd90.png";